import React, { useState, Suspense } from "react";
import "./App.css";
import { useEagerConnect, useInactiveListener } from "./hooks/useEagerConnect";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Footer, Header, ScrollToTop, Loader } from "./components";

const Home = React.lazy(() => import(`./screens/Home`));
const loader = <Loader />;
function App() {
  const [errorMessage, setErrorMessage] = useState();
  useEagerConnect(setErrorMessage);
  useInactiveListener();

  return (
    <div className="App">
      {errorMessage ? <div style={{ color: "red" }}>{errorMessage}</div> : null}
      <BrowserRouter>
        <ScrollToTop />
        <Suspense fallback={loader}>
          <Header setErrorMessage={setErrorMessage} />
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
          <Footer />
        </Suspense>
      </BrowserRouter>
    </div>
  );
}
// export default App;
export default function WrappedApp() {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <App />
    </Suspense>
  );
}
